import * as React from 'react';

import SyllabarySelector from '@/components/layouts/Glossary/SyllabarySelector';

import { Headline } from '../style';
import { Container, TermWrapper } from './style';

export const DISABLED_WORDS = ['ぬ', 'ね', 'の', 'む', 'め', 'ゆ', 'り', 'ろ'];

const TermTemplate: React.FC = () => {
  return (
    <Container>
      <Headline>競輪用語集</Headline>
      <TermWrapper>
        <SyllabarySelector
          disabledWords={DISABLED_WORDS}
          hasLink
          redirectTo={s => `/glossary/${s[0]}`}
        />
      </TermWrapper>
    </Container>
  );
};

export default TermTemplate;
